<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <SharedWindow
    title="Deposit"
    :is-big="isBig"
    :is-center="true"
    @close="handleClose"
  >
    <div :class="b('wrapper')">
      <div :class="b('fields')">
        <div :class="b('field')">
          <p :class="b('field-label')">
            {{ $t("Монета") }}
          </p>

          <SharedSelect
            view="light"
            :options="displayedCurrencyOptions"
            v-model:value="coinId"
            :isCryptoIcon="true"
            :icon="displayedCurrencyIcon"
            @update:value="loadChains"
          />
        </div>

        <div :class="b('field')" v-if="chains.length">
          <p :class="b('field-label')">
            {{ $t("Выберите сеть") }}
          </p>

          <SharedSelect
            view="light"
            :options="displayedChainOptions"
            v-model:value="chain"
            @update:value="getDepositAddress"
          />
        </div>

        <div :class="b('field')" v-if="address?.addressDeposit">
          <p :class="b('field-label')">
            {{ $t("Адрес кошелька") }}
            <b :class="b('copy_btn')" @click="copyAddressToCliboard">copy</b>
          </p>

          <p>{{ address.addressDeposit }}</p>
        </div>
        <div :class="b('field')" v-if="address?.tagDeposit">
          <p :class="b('field-label')">
            {{ $t("Адрес тэг кошелька") }}
            <b :class="b('copy_btn')" @click="copyTagToCliboard">copy</b>
          </p>

          <p>{{ address.tagDeposit }}</p>
        </div>
      </div>
    </div>
  </SharedWindow>
</template>
